/**
 * Debug overrides for contract interactions
 * This file provides mock implementations to test premium features without paying ETH or E3D
 */

// Debug flag to toggle test mode
let debugFakePremium = false;

// Toggle debug fake premium status
export const toggleDebugFakePremium = () => {
  debugFakePremium = !debugFakePremium;
  console.log(`Debug mode: Premium subscription ${debugFakePremium ? 'ACTIVE' : 'INACTIVE'} (Test mode)`);
  return debugFakePremium;
};

// Get debug status
export const isDebugFakePremium = () => {
  return debugFakePremium;
};

// Mock subscription details for testing
export const getMockSubscriptionDetails = (address) => {
  return {
    tier: 2, // Yearly subscription
    expiration: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000), // 1 year from now
    remainingMints: 10,
    isActive: true,
    paidWithE3D: true, // Mock as paid with E3D
    paymentMethod: 'E3D'
  };
};

// Override the getSubscriptionDetails function when in debug mode
export const getSubscriptionDetailsWithDebug = async (originalFunction, address) => {
  // If debug mode is active, return mock data
  if (debugFakePremium) {
    console.log('Debug mode: Returning mock subscription details');
    return getMockSubscriptionDetails(address);
  }
  
  // Otherwise, call the original function
  return originalFunction(address);
};
